const el = document.querySelector(".category-nav");

if (el) {
	console.log("category nav");
	const observer = new IntersectionObserver(
		([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
		{ threshold: [1] }
	);

	observer.observe(el);
}
